var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.customClasses,style:(_vm.customStyles),attrs:{"href":_vm.field.path,"target":_vm.targetContent}},[_vm._v(" "+_vm._s(_vm.field.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }